module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.loaded == 'true') ? _c('span', [(_vm._locutor.acf.imagen_alternativa != false) ? _c('main', {
    staticClass: "col-xs-12 npd"
  }, [_c('img', {
    attrs: {
      "src": _vm._locutor.acf.imagen_alternativa.sizes['1440x446'],
      "alt": "",
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded == 'true') ? _c('section', {
    staticClass: "col-xs-12 info-locutor"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inicio")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Locutores")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._locutor.title.rendered)
    }
  })])]), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm._locutor.title.rendered)
    }
  }), _vm._v(" "), (_vm._locutor.better_featured_image != false) ? _c('figure', {
    staticClass: "col-xxs-12 col-xs-3 npd"
  }, [_c('img', {
    staticClass: "shadow",
    attrs: {
      "src": _vm._locutor.better_featured_image.media_details.sizes['530x626'].source_url,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('article', {
    staticClass: "col-xxs-12 col-xs-9 desarrollo ",
    domProps: {
      "innerHTML": _vm._s(_vm._locutor.content.rendered)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loaded_programas == 'true') ? _c('section', {
    staticClass: "col-xs-12 programa-locutor"
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm._programas), function(programa) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-3 npd"
    }, [_c('div', {
      staticClass: "hidden-xs col-sm-5"
    }, [(programa.better_featured_image != null) ? _c('img', {
      attrs: {
        "src": programa.better_featured_image.media_details.sizes['100x100'].source_url,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-7 npd"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: programa.slug
          }
        }
      }
    }, [_c('p', [_vm._v("PROGRAMAS")]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(programa.title.rendered)
      }
    }), _vm._v(" "), (programa.acf.hasOwnProperty(_vm.horarios_texto)) ? _c('p', [_vm._v("Horario:")]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(programa.acf.horarios_texto)
      }
    })])], 1)]), _vm._v(" "), (_vm.loaded_audiosprograma == 'true') ? _c('div', {
      staticClass: "col-xs-12 col-sm-9 player-locutor"
    }, [_c('p', [_vm._v("ULTIMA REFLEXION")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "player__playlist"
    }, [_c('div', {
      staticClass: "compartir__player"
    }, [_c('button', [_c('i', {
      staticClass: "icon share"
    })]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": 'https://www.facebook.com/sharer/sharer.php?u=' + programa.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-facebook"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": 'https://twitter.com/share?url=' + programa.link + '&text=' + programa.title.rendered,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-twitter"
    })])]), _vm._v(" "), _c('li', {
      staticClass: "itemwa"
    }, [_c('a', {
      attrs: {
        "href": 'whatsapp://send?text=' + programa.link
      }
    }, [_c('i', {
      staticClass: "fa fa-whatsapp"
    })])])])]), _vm._v(" "), _c('a', {
      staticClass: "fav__player",
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "icon star",
      attrs: {
        "programa": programa.id
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "playlist"
    }, _vm._l((_vm.audiosprograma), function(audio) {
      return _c('li', {
        staticClass: "col-xs-12 npd",
        attrs: {
          "data-cover": _vm.theme_url + '/html/assets/img/imgplay.jpg',
          "data-descripcion": programa.soloexcerpt
        }
      }, [(audio.post_meta_fields.hasOwnProperty('_enclosure_mp3')) ? _c('a', {
        attrs: {
          "href": audio.post_meta_fields._enclosure_mp3
        }
      }, [_c('span', {
        staticClass: "titulo",
        domProps: {
          "innerHTML": _vm._s(audio.title.rendered)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "autor",
        domProps: {
          "innerHTML": _vm._s(audio.author_meta.display_name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "fecha",
        domProps: {
          "innerHTML": _vm._s(audio.fechaconformato)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "duracion"
      }, [_vm._v("3:22")])]) : _vm._e()])
    }))])]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.loaded_author == 'true') ? _c('section', {
    staticClass: "col-xs-12 block bgg articulos"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("OTRAS REFLEXIONES ")]), _vm._v(" "), _vm._l((_vm._postslocutor), function(post) {
    return _c('div', {
      staticClass: "col-xs-12 col-xs-6 col-md-3 artitem"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'post',
          params: {
            name: post.slug
          }
        }
      }
    }, [(post.better_featured_image !== null) ? _c('figure', [_c('img', {
      attrs: {
        "src": post.better_featured_image.media_details.sizes['536x516'].source_url,
        "alt": ""
      }
    })]) : (post.featured_image_src['full'][0]) ? _c('figure', [_c('img', {
      attrs: {
        "src": post.featured_image_src['full'][0],
        "alt": ""
      }
    })]) : _c('figure', [_c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/articulo.jpg',
        "alt": ""
      }
    })]), _vm._v(" "), _c('h4', {
      domProps: {
        "innerHTML": _vm._s(_vm._locutor.title.rendered)
      }
    }), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(post.soloexcerpt)
      }
    })])], 1)
  })], 2)])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed7075a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locutor.vue
// module id = 149
// module chunks = 0